import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse, TimeZone, User, userLoaders} from '../../../../domain';
import {Control, HttpPromiseState, newValueForSelection, validators} from '../../../../lib/helpers';

export class SetTimeZoneStore {
  timeZone: Control<TimeZone | null>;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null = null;

  @observable.ref
  options: readonly TimeZone[];

  constructor(readonly userId: number) {
    makeObservable(this);
    this.timeZone = new Control<TimeZone | null>('', null, validators.required);
    this.options = [];
  }

  @action
  init(user: User, timeZones: readonly TimeZone[]) {
    this.options = timeZones;
    this.timeZone.setValue(newValueForSelection(timeZones, user.TimeZone));
  }

  @action
  complete() {
    this.timeZone.markTouched();
    if (this.timeZone.invalid)
      return;
    if (this.save?.isPending === true)
      return;
    this.save = userLoaders.setTimeZone(this.userId, this.timeZone.value!.Id);
  }
}
